export default "__VITE_ASSET__79146cfc__"